export default __webpack_public_path__ + "static/media/heroBuilding.ee5365b1.png";